const defaultBreadCrumbState = {
  list: []
};

export const BreadCrumbState = { data: defaultBreadCrumbState }